import React, { useEffect, useState } from 'react'
import { Container, Dropdown, FormControl, Nav, Navbar } from 'react-bootstrap'
import logo from "./../../images/logo.png"
import { BiLogIn } from "react-icons/bi"
import { AiOutlineShoppingCart } from "react-icons/ai"
import UseLogged from '../../CustomHooks/Auth/UseLogged'
import UseGetAllItemsCart from '../../CustomHooks/Cart/UseGetAllItemsCart'
import { CiHeart } from "react-icons/ci";
import UseGetAllFavorite from '../../CustomHooks/Favorite/UseGetAllFavorite'


const NavBar = ({ onChangeSearchInput, searchInputValue }) => {

    const [isLogin, LogOut, role, token] = UseLogged();
    const [ItemsCartNumber] = UseGetAllItemsCart()
    const [favList, allFavorites, loading] = UseGetAllFavorite()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return (
        <Navbar variant="dark" expand="sm">
            <div className='container-md '>
                <Navbar.Brand>
                    <a href='/'>
                        <img src={logo} className='logo' alt="logo" />
                    </a>
                </Navbar.Brand>
                {windowWidth > 576 ? (
                    <div className='w-100'>
                        <FormControl
                            value={searchInputValue}
                            onChange={onChangeSearchInput}
                            type="text"
                            placeholder="search..."
                            className="me-2 w-100 text-center"
                            aria-label="Search"
                        />
                    </div>
                ) : null}

                <div className='d-flex mt-xs-3 mt-md-0'>
                    {
                        role && role === "user" ? (
                            <>
                                <Nav.Link href='/user/favoriteproducts'
                                    className="dark-color mx-3 d-flex align-items-center justify-content-center position-relative">
                                    <CiHeart className='fs-30 dark-color me-1 fw-bold' />
                                    <span class="position-absolute top-10 start-85 translate-middle badge rounded-pill bg-danger">
                                        {favList.length > 0 ? favList.length : 0}
                                    </span>
                                </Nav.Link>
                                <Nav.Link href='/cart'
                                    className="dark-color  me-2 d-flex align-items-center justify-content-center position-relative">
                                    <AiOutlineShoppingCart className='fs-16 dark-color me-1' />
                                    <p className='fs-16 fw-bold dark-color mb-0'>cart</p>
                                    <span class="position-absolute top-10 start-100 translate-middle badge rounded-pill bg-danger">
                                        {ItemsCartNumber || 0}
                                    </span>
                                </Nav.Link>
                            </>
                        ) : null
                    }
                    {isLogin ? (<Dropdown className='d-flex align-items-center'>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className='bg-transparent dark-color fw-bold fs-16'>
                            {isLogin.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {role ? (role === "user" ? (
                                <>
                                    <Dropdown.Item href="/user/allorders" className='fw-bold dark-color'>Orders</Dropdown.Item>
                                    <Dropdown.Item href="/user/alladdresses" className='fw-bold dark-color'>Address</Dropdown.Item>
                                    <Dropdown.Item href="/user/profile" className='fw-bold dark-color'>Profile</Dropdown.Item>
                                </>) : (<Dropdown.Item href="/admin/allproducts" className='fw-bold dark-color'>Dash board</Dropdown.Item>)) : null}
                            <Dropdown.Item href="/" onClick={LogOut} className='fw-bold dark-color'>LogOut</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>) : (<Nav.Link href='/login'
                        className="d-flex  justify-content-center align-items-center">
                        <BiLogIn className='fs-16 dark-color me-1  ms-2' />
                        <p className='fs-16 fw-bold dark-color mb-0'>login</p>
                    </Nav.Link>)}


                </div>

                {windowWidth < 576 ? (

                    <div className="mt-3 w-100">
                        <FormControl
                            value={searchInputValue}
                            onChange={onChangeSearchInput}
                            type="text"
                            placeholder="search..."
                            className="me-2 w-100 text-center"
                            aria-label="Search"
                        />
                    </div>
                ) : null}
            </div>
        </Navbar >
    )
}

export default NavBar